import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#f77d03',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'ABC PRIME',
  pwa: true,
  logo: '/images/home-logo.svg',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    // 未设置 sider.colorMenuBackground 时 ProLayout 会 fallback 为 transparent，侧栏会像「透明」叠在主区上
    bgLayout: '#f5f5f5',
    sider: {
      colorMenuBackground: '#ffffff',
    },
    header: {
      colorBgHeader: '#ffffff',
    },
  },
};

export default Settings;
